<template lang="pug">
footer.footer
  .container-fluid
    nav.pull-left
      ul
        li
          a(href='#')
            | {{ $t('Home') }}
        li
          a(href='http://www.eved.com/about-us/' target='_blank')
            | {{ $t('Company') }}
        li
          a(href='http://www.eved.com/news/' target='_blank')
            | {{ $t('News') }}
        li
          a(href='http://www.eved.com/careers/' target='_blank')
            | {{ $t('Careers') }}
        li |
        li
          a.lang(v-for='(lang, key) in langs', :class='{ "active": isLang(key) }', href='#', @click.prevent='setLang(key)') {{ lang }}
    p.copyright.pull-right
      | © 
      | {{year}}&nbsp;
      | Eved LLC
      | &nbsp;&amp;&nbsp;
      a(href='http://www.dozainer.com') dozainer&nbsp;
</template>
<script>

import {languages, isLang, loadLanguageAsync} from '@/lang/lang'

export default {
  data() {
    return {
      year: new Date().getFullYear(),
      langs: languages
    }
  },
  methods: {
    isLang,
    setLang(lang) {
      loadLanguageAsync(lang)
    }
  }
}
</script>
<style lang='scss'>
@import "~@/assets/sass/_variables.scss";

.footer .heart,
.theme .footer .lang.active,
.theme .footer .lang.active:focus {
  color: $secondary-01;
}

</style>



// WEBPACK FOOTER //
// index.vue?450aed9d